import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNetworkState } from './appStateHook';

const useInternet = () => {
    const { online, offline, disabled } = useNetworkState();
    const dispatch = useDispatch()

    // Registers event listeners to dispatch online/offline statuses to redux
    useEffect(() => {
        const handleOnline = () => {
            if (!disabled) {
                online(dispatch);
            }
        };
        const handleOffline = () => {
            if (!disabled) {
                offline(dispatch);
            }
        }

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        }
    }, [dispatch, online, offline, disabled]);
}

export default useInternet;